module.exports = __webpack_public_path__ + "img/1970East-070_WEB-min.44d4d54a.jpg";